<template>
  <div>
    <div>
      <!-- <mobile-cashback v-if="web_user" /> -->
      <template v-if="domainBasedBrand">
        <!-- <div class="filter-section section-b-space search-store">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="filter-panel">
                  <SearchBrands v-if="domainBasedBrand"></SearchBrands>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <stores-list /> -->
        <catalog />
      </template>
      <template v-else>
        <offer-list />
        <FilterPanel></FilterPanel>
        <Offer></Offer>
        <BrandsList></BrandsList>
      </template>
      <tap-top></tap-top>
    </div>
    <AppSection
      v-if="!domainBasedBrand && customizationLocal.app_section_availability"
    ></AppSection>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Offer from '../Blocks/offer'
import BrandsList from '../Blocks/BrandsList'
//import StoresList from '../Blocks/StoresList'
import OfferList from '../Blocks/Offers/OfferList'
// import MobileCashback from '@/components/Blocks/ProfileInfo/MobileCashback.vue'
import FilterPanel from '../Blocks/Filter/FilterPanel'
import AppSection from '../Footer/DownloadApp'
// import SearchBrands from '../Blocks/Filter/SearchBrands'
import TapTop from '../Blocks/TapTop'
import Catalog from '@/components/Pages/Catalog'

export default {
  name: 'Welcome',
  components: {
    Catalog,
    BrandsList,
    //StoresList,
    OfferList,
    FilterPanel,
    AppSection,
    Offer,
    // SearchBrands,
    TapTop,
    // MobileCashback,
  },
  computed: {
    ...mapGetters([
      '_T',
      'domainBasedBrand',
      'web_user',
      'customizationLocal',
      'customization',
    ]),
  },
  beforeRouteEnter(to, from, next) {
    if (to.query) {
      if (to.query.showLogin) {
        next(vm => vm.$bvModal.show('login'))
      } else {
        next()
      }
    } else {
      next()
    }
  },
}
</script>
